export default {
  CCY_PAIR: ['Ccy_Pair', 'CcyPair', 'Currency_Pair', 'CurrencyPair'],
  CURRENCY_1: ['Ccy1', 'Ccy_1'],
  CURRENCY_2: ['Ccy2', 'Ccy_2'],
  TENOR: ['Tenor', 'Tnr'],
  TENOR1: ['Tenor_1', 'Tnr_1', 'Tenor1', 'Tnr1'],
  TENOR2: ['Tenor_2', 'Tnr_2', 'Tenor2', 'Tnr2'],
  TRADE_DATETIME: [
    'TradeDateTime',
    'Trade_Date_Time',
    'Trade_DateTime',
    'ExecutionDateTime',
    'Execution_Date_Time',
    'Execution_DateTime',
    'DealDateTime',
    'Deal_Date_Time',
    'Deal_DateTime',
  ],
  VALUE_DATE: ['Value_Date', 'ValueDate', 'ValDate', 'Start_Date', 'StartDate'],
  MATURITY_DATE: [
    'Maturity_Date',
    'MaturityDate',
    'MatDate',
    'Settlement_Date',
    'SettlementDate',
    'SetDate',
  ],
  PRICE: [
    'Price',
    'TradePrice',
    'Trade_Price',
    'Trade Price',
    'ExecutionPrice',
    'Execution_Price',
    'Execution Price',
    'ExecPrice',
    'Exec Price',
    'Exec_Price',
    'DealPrice',
    'Deal Price',
    'Deal_Price',
    'Rate',
  ],
  SIDE: [
    'Side',
    'Side String',
    'Side_String',
    'SideString',
    'SideStr',
    'Side_Str',
  ],
  NOTIONAL_AMOUNT: [
    'Notional',
    'Amount',
    'Notional Amount',
    'Notional_Amount',
    'NotionalAmount',
    'Notional Traded',
    'Notional_Traded',
    'NotionalTraded',
    'Trade Amount',
    'Trade_Amount',
    'TradeAmount',
    'TradedAmount',
    'Traded_Amount',
    'Traded Amount',
    'Deal Amount',
    'Deal_Amount',
    'DealAmount',
    'Trade Size',
    'Trade_Size',
    'TradeSize',
    'Deal Size',
    'Deal_Size',
    'DealSize',
  ],
  TIME_ZONE: ['Time Zone', 'Time_Zone', 'TimeZone', 'TZ'],
  FORWARD_START_TENOR: [
    'Forward Start Tenor',
    'Forward_Start_Tenor',
    'ForwardStartTenor',
  ],
  SPOT_DELAY: [
    'Spot Delay',
    'Spot_Delay',
    'SpotDelay',
    'Spt Delay',
    'Spt_Delay',
    'SptDelay',
  ],
  IS_DOMESTIC_VARIANT: [
    'Is Domestic Variant',
    'Is_Domestic_Variant',
    'IsDomesticVariant',
    'DomesticVariant',
    'Domestic_Variant',
  ],
  IS_INTERNATIONAL_VARIANT: [
    'Is International Variant',
    'Is_International_Variant',
    'IsInternationalVariant',
    'International Variant',
    'International_Variant',
    'InternationalVariant',
  ],
  BENCHMARK: ['Benchmark', 'Bench_Mark', 'Bm', 'Bench', 'BMark'],
  EXPLICIT_COST: ['Explicit Cost', 'ExplicitCost', 'Explicit_Cost', 'Cost'],
  ORDER_ID: [
    'Order ID',
    'OrderID',
    'Order_ID',
    'RootContract_Id',
    'RootContractId',
  ],
  TRADE_ID: ['Trade ID', 'TradeID', 'Trade_ID', 'ID'],
  ORDER_TYPE: ['Order Type', 'OrderType', 'Order_Type'],
  SECURITY_TYPE: ['Security Type', 'SecurityType', 'Security_Type'],
  SECURITY_SUB_TYPE: [
    'Security Sub Type',
    'SecuritySubType',
    'Security_Sub_Type',
    'Security_SubType',
  ],
  INSTRUMENT_TYPE: [
    'Instrument Type',
    'Instrument_Type',
    'InstrumentType',
    'Component_Typology',
    'ComponentTypology',
  ],
  DESCRIPTION: ['Description', 'Desc'],
  TRADE_TYPE: ['Trade Type', 'TradeType', 'Trade_Type'],
  TRADER: [
    'Trader',
    'TraderName',
    'Trader Name',
    'Trader_Name',
    'TraderID',
    'Trader ID',
    'Trader_ID',
    'TraderCode',
    'Trader Code',
    'Trader_Code',
  ],
  DESK_LOCATION: [
    'Location',
    'Desk_Location',
    'DeskLocation',
    'Desk Location',
    'Desk',
    'TradeDesk',
    'Trade Desk',
    'Trade_Desk',
  ],
  COVER_PRICE: ['Cover_Price', 'CoverPrice', 'Cover Price'],
  LIMIT_PRICE: ['Limit_Price', 'LimitPrice', 'Limit Price', 'Lmt_Price', 'Lmt'],
  ORDER_SIZE: ['Order Size', 'Order_Size', 'OrderSize'],
  EVENT_TYPE: ['Event_Type', 'EventType', 'Event Type'],
  INSTRUCTIONS: ['Instructions'],
  STATUS: ['Status', 'Trade_Status', 'TradeStatus', 'Trade Status'],
  PM: ['PM', 'PortfolioManager', 'Portfolio_Manager', 'Portfolio Manager'],
  ACCOUNT: ['Account', 'AccountName', 'Account_Name', 'Account Name'],
  FUND: ['Fund', 'FundType', 'Fund_Type', 'Fund Type'],
  STRATEGY: ['Strategy', 'StrategyType', 'Strategy_Type', 'Strategy Type'],
  COUNTER_PARTY: ['Counterparty', 'CP', 'cpty'],
  PLATFORM: [
    'PlatformVenue',
    'Platform_Venue',
    'Platform',
    'Venue',
    'Plat',
    'Ven',
  ],
  OTHER_ID: ['Other_Id', 'Other Id', 'OtherId'],
  CONTRACT_TYPE: [
    'Contract_Type',
    'ContractType',
    'Contract_Typology',
    'ContractTypology',
  ],
  CONTRACT_ID: ['Contract_Id', 'ContractId'],
  PORTFOLIO: ['Portfolio'],
  PRICE_TYPE: ['Price_Type', 'PriceType'],
  SPOT_PRICE: ['Spot_Price', 'SpotPrice', 'Spt_Price', 'SptPrice'],
  FORWARD_POINTS: [
    'Forward_Points',
    'ForwardPoints',
    'FwdPoints',
    'Fwd_Points',
    'Fwd_Pts',
    'FwdPts',
    'Points',
    'ForwardPts',
    'Forward_Pts',
  ],
  NOTIONAL_ORDERED: ['NotionalOrdered', 'Notional_Ordered'],
  DEAL_TYPE: ['Deal_Type', 'DealType'],
  CUSTOM_BENCHMARK_1: [
    'Custom_Benchmark_1',
    'CustomBenchmark1',
    'Custom_Benchmark1',
    'CustomBenchmark_1',
    'Custom Benchmark 1',
  ],
  CUSTOM_BENCHMARK_2: [
    'Custom_Benchmark_2',
    'CustomBenchmark2',
    'Custom_Benchmark2',
    'CustomBenchmark_2',
    'Custom Benchmark 2',
  ],
  CUSTOM_BENCHMARK_3: [
    'Custom_Benchmark_3',
    'CustomBenchmark3',
    'Custom_Benchmark3',
    'CustomBenchmark_3',
    'Custom Benchmark 3',
  ],
  CUSTOM_BENCHMARK_4: [
    'Custom_Benchmark_4',
    'CustomBenchmark4',
    'Custom_Benchmark4',
    'CustomBenchmark_4',
    'Custom Benchmark 4',
  ],
  OTHER: ['Other_1', 'Other1', 'Other 1'],
  CUSTOM_1: ['Custom_1', 'Report_Date'],
  CUSTOM_2: ['Custom_2', 'Trade_Insertion_Datetime'],
  CUSTOM_3: ['Custom_3'],
  LEGAL_ENTITY: ['entity', 'Entity', 'ENTITY'],
};
